import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

interface CheckListItem {
  id: number;
  name: string;
}

@Component({
  selector: 'tp-check-list',
  templateUrl: './check-list.component.html',
  styleUrls: ['./check-list.component.scss']
})
export class CheckListComponent {
  @Input() items: CheckListItem[] = [];
  @Input() label = '';
  @Input() required = false;
  @Input() selectedIds: number[] = [];
  @Input() error: string = null;
  @Input() tooltipText = '';

  @Output() selectionChange = new EventEmitter<number[]>();

  get isAllSelected(): boolean {
    return this.items.length === this.selectedIds.length;
  }

  toggleSelectAll(event: MatCheckboxChange): void {
    const newSelectionState = event.checked ? this.items.map(({ id }) => id) : [];
    this.selectionChange.emit(newSelectionState);
  }

  itemSelectionChange(event: MatCheckboxChange, id: number): void {
    const newSelectionState = event.checked
      ? this.selectedIds.concat(id)
      : this.selectedIds.filter(item => item !== id);

    this.selectionChange.emit(newSelectionState);
  }
}
